module.exports = __webpack_public_path__ + "img/green-pita-01.1d653752.png";